var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wp-history-internal-comment" }, [
    _c("span", { staticClass: "workpermit-content-slot__history-label" }, [
      _vm._v(_vm._s(_vm.$t("workPermit.internalCommentsHistoryLabel"))),
    ]),
    _vm._v(" "),
    _c("pre", { staticClass: "workpermit-content-slot__history-pre" }, [
      _vm._v(_vm._s(_vm.text)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }